<template>
	<!--
		Guscio delle schede del BO aperte come pagina (inserimento, modifica, dettaglio):
		toolbar chiara come le liste con la freccia per tornare indietro, bottone del
		tutorial, contenuto a sezioni e barra delle azioni attaccata al fondo dello schermo.
	-->
	<v-card width="100%" outlined elevation-0 class="form-page">
		<v-toolbar flat class="border_bottom" shaped>
			<v-btn icon class="mr-1" :title="backLabel" data-tour="back" @click="$emit('back')">
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>
			<v-toolbar-title>
				{{ title }}<span v-if="subtitle" class="form-page-subtitle"> · {{ subtitle }}</span>
			</v-toolbar-title>
			<!-- tutorial a destra del titolo, staccato quanto basta -->
			<v-btn v-if="tutorial" class="ml-6" outlined color="primary" data-tour="tutorial" @click="$emit('tutorial')">
				<v-icon left>mdi-school-outline</v-icon>
				Tutorial guidato
			</v-btn>
			<v-spacer></v-spacer>
			<slot name="toolbar"></slot>
		</v-toolbar>

		<div class="pa-3">
			<slot></slot>
		</div>

		<!-- azioni in fondo: la barra resta attaccata al bordo dello schermo mentre si scorre -->
		<div v-if="saveLabel || $slots.actions" class="form-page-actions">
			<v-btn text @click="$emit('back')">Annulla</v-btn>
			<v-spacer></v-spacer>
			<slot name="actions"></slot>
			<v-btn v-if="saveLabel" depressed color="primary" data-tour="save" :disabled="saveDisabled" @click.prevent="$emit('save')">
				<v-icon left>mdi-content-save-outline</v-icon>
				{{ saveLabel }}
			</v-btn>
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'FormPage',
	props: {
		title: { type: String, required: true },
		subtitle: { type: String, default: '' },
		// testo del tooltip sulla freccia: dice dove si torna ("Torna alla lista", "Torna al nuovo acquisto"...)
		backLabel: { type: String, default: 'Torna alla lista' },
		tutorial: { type: Boolean, default: false },
		// vuoto: niente bottone di salvataggio (es. dettaglio in sola lettura)
		saveLabel: { type: String, default: '' },
		saveDisabled: { type: Boolean, default: false },
	},
};
</script>

<style scoped>
.form-page-subtitle {
	font-size: 15px;
	color: #5f6b7a;
}
.form-page-actions {
	position: sticky;
	bottom: 0;
	z-index: 3;
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 16px;
	background: #fff;
	border-top: 1px solid #e1e7ef;
}
</style>
